import { IconSizes } from '../../visuals/Icons/type';
import Warning from '../../visuals/Icons/Warning';

import type { JSX } from "react";

interface IWarningBanner {
  title: string;
  text: string;
  onButtonClick: () => void;
  buttonTitle: string;
  backgroundColor?: string;
  icon?: JSX.Element;
}

const WarningBanner = ({
  backgroundColor = 'var(--clr-secondary-3)',
  title,
  text,
  icon,
  onButtonClick,
  buttonTitle,
}: IWarningBanner) => {
  return (
    <div data-testid="Alert-Banner" style={{ backgroundColor }}>
      <div className="tw-mx-auto tw-flex tw-w-full tw-max-w-[1440px] tw-items-center tw-justify-between tw-px-3 tw-py-3 md:tw-px-4">
        <div className="tw-flex tw-items-center">
          <div className="tw-mr-6 tw-hidden tw-items-center tw-space-x-2 md:tw-flex">
            {icon ? icon : <Warning size={IconSizes.md} />}
            <p className="tw-lf-body-bold-md">{title}</p>
          </div>
          <p className="tw-lf-body-regular-sm tw-leading-[21px] md:tw-lf-body-regular-md phone:tw-w-56 phone-l:tw-w-fit">
            {text}
          </p>
        </div>
        <button
          data-testid="Alert-Banner-Button"
          onClick={onButtonClick}
          className="tw-lf-button tw-lf-button-secondary tw-lf-button-sm md:tw-lf-button-md"
        >
          {buttonTitle}
        </button>
      </div>
    </div>
  );
};

export default WarningBanner;
